import { render, staticRenderFns } from "./ChannelDeleteModal.vue?vue&type=template&id=253de152&"
import script from "./ChannelDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports